import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared';

@Injectable()
export class BatchService {
  public constructor(private _apiService: ApiService) {}

  getNextBatchNumber(year: number = 0) {
    const url = year > 0 ? `Batch/GetNextBatch/${year}` : 'Batch/GetNextBatch';
    return this._apiService.get(url, this._apiService.getDefaultApiCacheOptionsForNoCache());
  }

  getLastUsedBatchNumber(year: number = 0): Promise<number> {
    const url = year > 0 ? `Batch/GetLatestBatchNumber/${year}` : 'Batch/GetLatestBatchNumber';
    return this._apiService.get(url, this._apiService.getDefaultApiCacheOptionsForNoCache());
  }
}
